import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import Button from '@/components/form/Button';
import { useAuth } from '@/context/AuthContext';

export default function Imprint() {
  const { user } = useAuth();

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-xl my-10">
      {!user && (
        <Button
          variant="ghost"
          size="sm"
          icon={<ArrowLeftIcon className="h-4 w-4" />}
          onClick={() => window.location.href = '/'}
          className="mb-6"
        >
          Back to Home
        </Button>
      )}

      <h1 className="text-4xl font-extrabold text-blue-600 mb-10 text-center">Legal Notice (Imprint)</h1>

      <div className="prose prose-lg prose-blue max-w-none">
        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b pb-2">Information according to § 5 TMG</h2>
          <div className="mt-4 p-4 bg-gray-50 rounded-lg">
            <p className="text-gray-700">
              Dennis Horn<br />
              Wadgasserstr. 112<br />
              66787 Wadgassen<br />
              Germany
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b pb-2">Contact</h2>
          <div className="mt-4 space-y-2 text-gray-700">
            <p>
              Email: <a href="mailto:info@snapvote.ai" className="text-primary-600 hover:text-primary-700">info@snapvote.ai</a>
            </p>
            <p>
              Website: <a href="https://snapvote.ai" className="text-primary-600 hover:text-primary-700">www.snapvote.ai</a>
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b pb-2">Content Responsibility</h2>
          <div className="mt-4 space-y-4 text-gray-700">
            <p>
              SnapVote is an interactive community platform where users independently create SNAPs (polls) on various topics and vote on them. The platform itself does not produce editorial content nor performs journalistic evaluation or categorization.
            </p>
            <p>
              An integrated AI solely assists in identifying current viral trends and converting them into neutral poll questions. However, this AI does not interpret or evaluate content, nor does it produce any editorial contributions.
            </p>
            <p>
              SnapVote merely provides the technical infrastructure enabling users to create and participate in polls. Responsibility for the contents of the SNAPs lies with the respective users.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b pb-2">Liability for Content</h2>
          <div className="mt-4 space-y-4 text-gray-700">
            <p>
              The content of our pages was created with the utmost care. However, we cannot guarantee accuracy, completeness, or timeliness. As service providers, we are responsible for our content on these pages according to § 7 para. 1 TMG under general law.
            </p>
            <p>
              According to §§ 8 to 10 TMG, we as service providers are not obliged to monitor transmitted or stored third-party information or to investigate circumstances indicating illegal activities. Obligations to remove or block the use of information according to general law remain unaffected.
            </p>
            <p>
              Liability in this regard is only possible from the time of knowledge of a specific infringement. Upon notification of violations, we will remove the respective content immediately.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b pb-2">Liability for Links</h2>
          <div className="mt-4 text-gray-700">
            <p>
              Our offer includes links to external third-party websites whose content is beyond our control. Therefore, we cannot assume any liability for external content. Responsibility for the content of linked pages always lies with the respective provider or operator. Linked pages were reviewed for possible violations at the time of linking, with no illegal content recognizable at that point.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b pb-2">Copyright</h2>
          <div className="mt-4 text-gray-700">
            <p>
              Content created by site operators is subject to German copyright law. Reproduction, editing, distribution, and any kind of exploitation outside copyright require the written consent of the author or creator. Downloads and copies are permitted for private, non-commercial use only.
            </p>
          </div>
        </section>

        <footer className="mt-12 pt-8 border-t">
          <div className="text-sm text-gray-500 space-y-4">
            <p>
              <strong>Note:</strong> We hereby explicitly object to the use of contact details provided in compliance with the imprint obligation for sending unsolicited advertising and information material. The site operators reserve the right to take legal action against unsolicited advertising, such as spam emails.
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}